import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from '../Kit/Buttons/Button'

export const CustomButton = ({ children, onClick }) => (
  <StyledButton variant="contained" onClick={onClick} data-test="custom-button">
    {children}
  </StyledButton>
)

const StyledButton = styled(Button)`
  display: inline-flex;
  background-color: #000000;
  color: white;
  margin-top: 0;
  &:hover {
    background-color: #000000;
  }
`

CustomButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired,
}
